(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-home-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHph(root) {
    if (!root || root.getAttribute('data-hph-init')) return;
    root.setAttribute('data-hph-init', '1');

    /* countdown: counts down to the end date entered in the theme editor, then hides itself */
    var cd = root.querySelector('[data-hph-countdown]');
    if (cd) {
      var end = new Date((cd.getAttribute('data-end') || '').replace(' ', 'T')).getTime();
      if (!isNaN(end)) {
        var timer;
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var tick = function () {
          var ms = end - Date.now();
          if (ms <= 0) { cd.setAttribute('hidden', ''); clearInterval(timer); return; }
          var s = Math.floor(ms / 1000);
          cd.querySelector('[data-u="d"]').textContent = pad(Math.floor(s / 86400));
          cd.querySelector('[data-u="h"]').textContent = pad(Math.floor(s % 86400 / 3600));
          cd.querySelector('[data-u="m"]').textContent = pad(Math.floor(s % 3600 / 60));
          cd.querySelector('[data-u="s"]').textContent = pad(s % 60);
          cd.removeAttribute('hidden');
        };
        tick();
        timer = setInterval(tick, 1000);
      }
    }
  }

  function initAll() { [].forEach.call(document.querySelectorAll('.hph'), initHph); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-home-v4"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHph(root) {
    if (!root || root.getAttribute('data-hph-init')) return;
    root.setAttribute('data-hph-init', '1');

    /* countdown: counts down to the end date entered in the theme editor, then hides itself */
    var cd = root.querySelector('[data-hph-countdown]');
    if (cd) {
      var end = new Date((cd.getAttribute('data-end') || '').replace(' ', 'T')).getTime();
      if (!isNaN(end)) {
        var timer;
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var tick = function () {
          var ms = end - Date.now();
          if (ms <= 0) { cd.setAttribute('hidden', ''); clearInterval(timer); return; }
          var s = Math.floor(ms / 1000);
          cd.querySelector('[data-u="d"]').textContent = pad(Math.floor(s / 86400));
          cd.querySelector('[data-u="h"]').textContent = pad(Math.floor(s % 86400 / 3600));
          cd.querySelector('[data-u="m"]').textContent = pad(Math.floor(s % 3600 / 60));
          cd.querySelector('[data-u="s"]').textContent = pad(s % 60);
          cd.removeAttribute('hidden');
        };
        tick();
        timer = setInterval(tick, 1000);
      }
    }
  }

  function initAll() { [].forEach.call(document.querySelectorAll('.hph'), initHph); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-home-v5"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHph(root) {
    if (!root || root.getAttribute('data-hph-init')) return;
    root.setAttribute('data-hph-init', '1');

    /* countdown: counts down to the end date entered in the theme editor, then hides itself */
    var cd = root.querySelector('[data-hph-countdown]');
    if (cd) {
      var end = new Date((cd.getAttribute('data-end') || '').replace(' ', 'T')).getTime();
      if (!isNaN(end)) {
        var timer;
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var tick = function () {
          var ms = end - Date.now();
          if (ms <= 0) { cd.setAttribute('hidden', ''); clearInterval(timer); return; }
          var s = Math.floor(ms / 1000);
          cd.querySelector('[data-u="d"]').textContent = pad(Math.floor(s / 86400));
          cd.querySelector('[data-u="h"]').textContent = pad(Math.floor(s % 86400 / 3600));
          cd.querySelector('[data-u="m"]').textContent = pad(Math.floor(s % 3600 / 60));
          cd.querySelector('[data-u="s"]').textContent = pad(s % 60);
          cd.removeAttribute('hidden');
        };
        tick();
        timer = setInterval(tick, 1000);
      }
    }
  }

  function initAll() { [].forEach.call(document.querySelectorAll('.hph'), initHph); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["night-beam-haus-v16"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHpp(root) {
    if (!root || root.getAttribute('data-hpp-init')) return;
    root.setAttribute('data-hpp-init', '1');

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = root.getAttribute('data-cur') || '';
    var label = root.getAttribute('data-label') || 'Add to cart';
    var soldout = root.getAttribute('data-soldout') || 'Sold out';
    var stickyLabel = root.getAttribute('data-sticky-label') || 'Choose bundle';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var cartAdd = root.getAttribute('data-cart-add') || '/cart/add.js';
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-hpp-variants]').textContent); } catch (e) {}
    var select = root.querySelector('.hpp-select');
    var form = root.querySelector('.hpp-form');
    var buy = root.querySelector('[data-hpp-buy]');
    var main = root.querySelector('[data-hpp-main]');
    var stage = root.querySelector('[data-hpp-stage]');
    var thumbs = [].slice.call(root.querySelectorAll('.hpp-thumb'));
    var qtyInput = root.querySelector('[data-hpp-qty]');
    var tierInputs = [].slice.call(root.querySelectorAll('[data-hpp-tier]'));
    var lastId = select ? String(select.value) : '';
    var index = 0;

    function byId(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }
    function setText(sel, txt) {
      [].forEach.call(root.querySelectorAll(sel), function (n) { n.textContent = txt; });
    }
    function toggle(sel, show) {
      [].forEach.call(root.querySelectorAll(sel), function (n) {
        if (show) n.removeAttribute('hidden'); else n.setAttribute('hidden', '');
      });
    }

    /* gallery + swipe */
    function showThumb(i) {
      if (!thumbs.length || !main) return;
      index = (i + thumbs.length) % thumbs.length;
      var t = thumbs[index];
      main.removeAttribute('srcset');
      main.src = t.getAttribute('data-src');
      main.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      t.scrollIntoView && t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showThumb(i); }); });
    var prev = root.querySelector('[data-hpp-prev]');
    var next = root.querySelector('[data-hpp-next]');
    if (prev) prev.addEventListener('click', function () { showThumb(index - 1); });
    if (next) next.addEventListener('click', function () { showThumb(index + 1); });
    if (stage && thumbs.length > 1) {
      var sx = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        sx = null;
        if (Math.abs(dx) > 40) showThumb(index + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* bundle tiers */
    function selectedTier() {
      for (var i = 0; i < tierInputs.length; i++) if (tierInputs[i].checked) return i;
      return -1;
    }
    function syncTotal() {
      var v = select ? byId(select.value) : null;
      if (!v) return;
      var i = selectedTier();
      var txt = (i > -1 && v.tiers && v.tiers[i]) ? v.tiers[i].total : v.price;
      setText('[data-hpp-total]', cur + txt);
    }
    function paintTiers(v) {
      if (!v || !v.tiers) return;
      tierInputs.forEach(function (inp) {
        var i = parseInt(inp.getAttribute('data-hpp-tier'), 10);
        var box = inp.parentNode;
        var t = v.tiers[i];
        if (!t || !box) return;
        var tot = box.querySelector('.hpp-tier-total');
        var was = box.querySelector('.hpp-tier-was');
        var unit = box.querySelector('.hpp-tier-unit');
        if (tot) tot.textContent = cur + t.total;
        if (was) {
          was.textContent = cur + t.was;
          if (!t.discounted) was.setAttribute('hidden', ''); else was.removeAttribute('hidden');
        }
        if (unit) unit.textContent = cur + t.unit + ' each';
      });
    }

    /* variants */
    function applyVariant(v) {
      if (!v) return;
      lastId = String(v.id);
      var onSale = v.compare_raw > v.price_raw;
      var pct = onSale ? Math.floor((v.compare_raw - v.price_raw) * 100 / v.compare_raw) : 0;
      setText('[data-hpp-price]', cur + v.price);
      setText('[data-hpp-compare]', cur + v.compare);
      toggle('[data-hpp-compare]', onSale);
      setText('[data-hpp-save]', 'Save ' + pct + '%');
      toggle('[data-hpp-save]', onSale);
      setText('[data-hpp-badge]', '-' + pct + '%');
      toggle('[data-hpp-badge]', onSale);
      setText('[data-hpp-label]', v.available ? label : soldout);
      setText('[data-hpp-sticky-label]', v.available ? stickyLabel : soldout);
      [].forEach.call(root.querySelectorAll('[data-hpp-submit],[data-hpp-cta]'), function (b) {
        if (v.available) b.removeAttribute('disabled'); else b.setAttribute('disabled', '');
      });
      paintTiers(v);
      syncTotal();
      if (v.image_id) {
        for (var i = 0; i < thumbs.length; i++) {
          if (String(thumbs[i].getAttribute('data-id')) === String(v.image_id)) { showThumb(i); break; }
        }
      }
    }
    function syncChips(v) {
      [].forEach.call(root.querySelectorAll('.hpp-opt'), function (fs, i) {
        [].forEach.call(fs.querySelectorAll('input'), function (inp) { inp.checked = (inp.value === v.options[i]); });
      });
    }
    function pickFromChips() {
      var sel = [];
      [].forEach.call(root.querySelectorAll('.hpp-opt'), function (fs) {
        var c = fs.querySelector('input:checked');
        sel.push(c ? c.value : null);
      });
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) if (variants[i].options[j] !== sel[j]) { ok = false; break; }
        if (ok) {
          if (select) select.value = variants[i].id;
          applyVariant(variants[i]);
          return;
        }
      }
    }
    function syncFromSelect() {
      if (!select) return;
      var v = byId(select.value);
      if (v) { applyVariant(v); syncChips(v); }
    }
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.name && t.name.indexOf('hpp-opt-') === 0) pickFromChips();
      else if (t === select) syncFromSelect();
      else if (t.hasAttribute && t.hasAttribute('data-hpp-tier')) {
        if (qtyInput) qtyInput.value = t.value;
        var shownQty = root.querySelector('[data-hpp-qty-visible]');
        if (shownQty) shownQty.value = t.value;
        syncTotal();
      }
    });
    setInterval(function () {
      if (!document.hidden && select && String(select.value) !== lastId) syncFromSelect();
    }, 400);

    /* Quantity buttons select the corresponding 1, 2 or 3 pack when tiers exist. */
    [].forEach.call(root.querySelectorAll('[data-qty]'), function (b) {
      b.addEventListener('click', function () {
        var shown = root.querySelector('[data-hpp-qty-visible]');
        if (!shown) return;
        var n = Math.max(1, (parseInt(shown.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
        if (tierInputs.length) {
          n = Math.min(3, n);
          var chosen = null;
          tierInputs.forEach(function (t) { if (Number(t.value) === n) chosen = t; });
          if (!chosen) return;
          chosen.checked = true;
          chosen.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          shown.value = n;
        }
      });
    });

    /* add-on (card + details sheet) */
    var addonCheck = root.querySelector('[data-hpp-addon-check]');
    var addonSel = root.querySelector('[data-hpp-addon-select]');
    var modal = root.querySelector('[data-hpp-modal]');
    var addonVars = [];
    try { addonVars = JSON.parse(root.querySelector('[data-hpp-addon-variants]').textContent); } catch (e) {}
    function addonVariant() {
      if (addonSel) {
        for (var i = 0; i < addonVars.length; i++) if (String(addonVars[i].id) === String(addonSel.value)) return addonVars[i];
      }
      for (var j = 0; j < addonVars.length; j++) if (addonVars[j].available) return addonVars[j];
      return addonVars[0] || null;
    }
    function syncAddonPrice() {
      var v = addonVariant();
      if (!v) return;
      setText('[data-hpp-addon-price]', cur + v.price);
      setText('[data-hpp-addon-plus]', '+' + cur + v.price);
    }
    if (addonSel) addonSel.addEventListener('change', syncAddonPrice);
    function closeModal() { if (modal && modal.open) modal.close(); }
    if (modal) {
      [].forEach.call(modal.querySelectorAll('[data-hpp-modal-close]'), function (b) { b.addEventListener('click', closeModal); });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      modal.addEventListener('close', function () { document.documentElement.classList.remove('hpp-lock'); });
      var confirmBtn = modal.querySelector('[data-hpp-addon-confirm]');
      if (confirmBtn) confirmBtn.addEventListener('click', function () {
        if (addonCheck && !addonCheck.disabled) addonCheck.checked = true;
        closeModal();
      });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!addonCheck || !addonCheck.checked) return;
        var av = addonVariant();
        if (!av || !select) return;
        e.preventDefault();
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : (parseInt((root.querySelector('[data-hpp-qty-visible]') || {}).value, 10) || 1);
        var items = [{ id: Number(select.value), quantity: qty }, { id: Number(av.id), quantity: 1 }];
        fetch(cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          window.location.href = cartUrl;
        }).catch(function () {
          HTMLFormElement.prototype.submit.call(form);
        });
      });
    }

    /* Sticky button: scroll to the bundle picker (falls back to the buy box) */
    function goBundles() {
      var tg = root.querySelector('[data-hpp-tiers]') || buy;
      if (!tg) return;
      tg.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: tg === buy ? 'start' : 'center' });
    }
    [].forEach.call(root.querySelectorAll('[data-hpp-cta]'), function (b) {
      b.addEventListener('click', goBundles);
    });

    /* sticky bar: visible whenever the main add-to-cart button is off screen */
    var sticky = root.querySelector('[data-hpp-sticky]');
    var atc = root.querySelector('[data-hpp-submit]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(atc);
    }
    /* photo strip arrows */
    [].forEach.call(root.querySelectorAll('[data-hpp-strip]'), function (b) {
      b.addEventListener('click', function () {
        var tr = root.querySelector('[data-hpp-strip-track]');
        if (!tr) return;
        var dir = parseInt(b.getAttribute('data-hpp-strip'), 10) || 1;
        tr.scrollBy({ left: dir * Math.max(240, tr.clientWidth * 0.8), behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    /* before / after slider */
    [].forEach.call(root.querySelectorAll('[data-hpp-ba]'), function (ba) {
      var r = ba.querySelector('.hpp-ba-range');
      if (!r) return;
      var set = function () { ba.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set);
      set();
    });

    /* Honest repeating 12-hour display: anchored to local noon and midnight. */
    var cd = root.querySelector('[data-hpp-countdown]');
    if (cd) {
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var now = new Date();
        var next = new Date(now);
        next.setHours(now.getHours() < 12 ? 12 : 24, 0, 0, 0);
        var sec = Math.max(0, Math.floor((next.getTime() - now.getTime()) / 1000));
        cd.querySelector('[data-u="h"]').textContent = pad(Math.floor(sec / 3600));
        cd.querySelector('[data-u="m"]').textContent = pad(Math.floor(sec % 3600 / 60));
        cd.querySelector('[data-u="s"]').textContent = pad(sec % 60);
        cd.removeAttribute('hidden');
      };
      tick();
      var timer = setInterval(tick, 1000);
      document.addEventListener('shopify:section:unload', function (e) {
        if (e.target && e.target.contains(root)) clearInterval(timer);
      });
    }

    /* initial sync */
    if (select) { var v0 = byId(select.value); if (v0) { paintTiers(v0); syncTotal(); } }
    syncAddonPrice();
  }

  function initAll() { [].forEach.call(document.querySelectorAll('.hpp'), initHpp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spooky-broom-v9"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHpp(root){
    if(!root||root.getAttribute('data-hpp-init'))return;
    root.setAttribute('data-hpp-init','1');
    var main=root.querySelector('[data-hpp-main]');
    var stage=root.querySelector('[data-hpp-stage]');
    var thumbs=[].slice.call(root.querySelectorAll('.hpp-thumb'));
    var index=0;
    function showThumb(i){
      if(!thumbs.length||!main)return;
      index=(i+thumbs.length)%thumbs.length;
      var t=thumbs[index];
      main.removeAttribute('srcset');
      main.src=t.getAttribute('data-src');
      main.alt=t.getAttribute('data-alt')||'';
      thumbs.forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
    }
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){showThumb(i);});});
    var prev=root.querySelector('[data-hpp-prev]');
    var next=root.querySelector('[data-hpp-next]');
    if(prev)prev.addEventListener('click',function(){showThumb(index-1);});
    if(next)next.addEventListener('click',function(){showThumb(index+1);});
    if(stage&&thumbs.length>1){
      var sx=null;
      stage.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
      stage.addEventListener('touchend',function(e){
        if(sx===null)return;
        var dx=e.changedTouches[0].clientX-sx;sx=null;
        if(Math.abs(dx)>40)showThumb(index+(dx<0?1:-1));
      },{passive:true});
    }
    var qtyInput=root.querySelector('[data-hpp-qty]');
    [].forEach.call(root.querySelectorAll('[data-qty]'),function(b){
      b.addEventListener('click',function(){
        if(!qtyInput)return;
        var n=parseInt(qtyInput.value,10)||1;
        qtyInput.value=Math.max(1,n+parseInt(b.getAttribute('data-qty'),10));
      });
    });
  }
  function initAll(){[].forEach.call(document.querySelectorAll('.hpp'),initHpp);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);
  else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
